var _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftEdge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Microsoft_Edge_48",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "none",
    fill: "#000000",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.92 0 0 0.92 24 24)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1.34 3.47)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(30,136,229)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-22.66, -27.47)",
    d: "M 40.69 35.42 C 31.54 47.300000000000004 19.279999999999998 44.22 14.459999999999997 41.52 C 7.109999999999998 37.410000000000004 1.9599999999999973 27.840000000000003 5.019999999999998 18.270000000000003 C 5.919999999999998 15.450000000000003 7.289999999999997 13.040000000000003 8.999999999999998 11.040000000000003 C 10.669999999999998 11.170000000000003 12.649999999999999 11.170000000000003 14.999999999999998 11.000000000000004 C 29 10.000000000000004 33 22.000000000000004 32 25.000000000000004 C 31.49 26.530000000000005 29.68 27.020000000000003 28.03 27.130000000000003 C 28.19 26.910000000000004 28.39 26.590000000000003 28.67 26.110000000000003 C 29.540000000000003 24.570000000000004 29.650000000000002 21.620000000000005 26.94 19.840000000000003 C 24.330000000000002 18.140000000000004 21.51 19.190000000000005 20.060000000000002 21.120000000000005 C 18.610000000000003 23.040000000000006 19.180000000000003 25.930000000000003 19.69 27.210000000000004 C 21.89 32.730000000000004 25.950000000000003 34.160000000000004 28.71 34.99 C 31.47 35.82 35.57 35.7 37.760000000000005 34.800000000000004 C 39.940000000000005 33.89000000000001 40.56 33.370000000000005 40.980000000000004 33.830000000000005 C 41.41 34.29 41.11 34.82 40.69 35.42 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 4.13 7.94)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(13,71,161)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-28.13, -31.94)",
    d: "M 40.732 35.42 C 37.252 39.94 33.322 42.29 29.522 43.33 C 29.491999999999997 43.339999999999996 29.462 43.339999999999996 29.442 43.35 C 27.242 43.77 25.492 43.43 23.592 43.06 C 20.502 42.46 16.241999999999997 39.050000000000004 15.211999999999998 32.88 C 14.331999999999997 27.570000000000004 16.842 23.07 20.802 20.340000000000003 C 20.541999999999998 20.580000000000002 20.312 20.840000000000003 20.102 21.120000000000005 C 18.652 23.040000000000006 19.222 25.930000000000003 19.732 27.210000000000004 C 21.932 32.730000000000004 25.991999999999997 34.160000000000004 28.752 34.99 C 31.512 35.82 35.612 35.7 37.802 34.800000000000004 C 39.982 33.89000000000001 40.602 33.370000000000005 41.022 33.830000000000005 C 41.452 34.29 41.152 34.82 40.732 35.42 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -8.45 -10.22)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,229,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-15.55, -13.78)",
    d: "M 26.94 4.25 C 26.96 4.51 26.970000000000002 4.79 26.970000000000002 5.0600000000000005 C 26.970000000000002 8.84 25.220000000000002 12.2 22.490000000000002 14.38 C 21.470000000000002 13.860000000000001 20.28 13.440000000000001 18.840000000000003 13.16 C 14.770000000000003 12.38 8.210000000000003 14.26 5.540000000000003 18.93 C 4.660000000000003 20.46 4.290000000000003 22.03 4.130000000000003 23.48 C 4.170000000000003 21.77 4.460000000000003 20.02 5.020000000000002 18.27 C 8.31 8.01 17.86 3.05 26.94 4.25 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 11.64 -3.74)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,230,118)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-35.64, -20.26)",
    d: "M 41.4 27.89 C 38.64 30.67 35.129999999999995 30.75 32.73 30.62 C 30.319999999999997 30.5 29.139999999999997 29.8 28.039999999999996 29.12 C 26.929999999999996 28.43 27.559999999999995 27.75 27.669999999999995 27.6 C 27.779999999999994 27.450000000000003 28.049999999999994 27.19 28.669999999999995 26.110000000000003 C 28.959999999999994 25.6 29.169999999999995 24.930000000000003 29.209999999999994 24.200000000000003 C 33.82999999999999 20.770000000000003 37.169999999999995 15.710000000000003 38.36999999999999 9.860000000000003 C 41.28999999999999 12.810000000000002 42.66999999999999 16.070000000000004 43.15999999999999 17.470000000000002 C 44.04 19.99 44.71 24.56 41.4 27.89 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 6.43 -9.77)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(29,233,182)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-30.43, -14.22)",
    d: "M 38.37 9.85 L 38.37 9.86 C 37.169999999999995 15.709999999999999 33.83 20.77 29.209999999999997 24.2 C 29.24 23.779999999999998 29.209999999999997 23.33 29.109999999999996 22.88 C 29.109999999999996 22.86 29.099999999999994 22.84 29.099999999999994 22.83 C 28.849999999999994 21.36 28.109999999999996 19.5 26.879999999999995 18.06 C 25.659999999999997 16.619999999999997 24.359999999999996 15.329999999999998 22.489999999999995 14.379999999999999 C 25.219999999999995 12.2 26.969999999999995 8.84 26.969999999999995 5.059999999999999 C 26.969999999999995 4.789999999999999 26.959999999999994 4.509999999999999 26.939999999999994 4.249999999999998 C 27.339999999999993 4.299999999999998 27.729999999999993 4.3599999999999985 28.129999999999995 4.439999999999999 C 32.74 5.33 36.04 7.49 38.37 9.85 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftEdge);
export default __webpack_public_path__ + "static/media/microsoft_edge.31e69500569746dd1e85af85ea1d0945.svg";
export { ForwardRef as ReactComponent };